/**
 * @fileoverview Requests Chart
 * @description Request count and response time line chart with status code breakdown.
 */

import React from 'react';
import { Box, Typography, Paper, Skeleton } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';
import { formatTimestamp } from '../utils/timeRangeUtils';

const RequestsChart = ({ data, loading, timeRange }) => {
  if (loading) {
    return <Skeleton variant="rounded" height={300} sx={{ mb: 3 }} />;
  }

  const rows = data?.rows || [];
  if (!rows.length) {
    return (
      <Paper sx={{ p: 3, mb: 3, textAlign: 'center' }}>
        <Typography color="text.secondary">No request data available.</Typography>
      </Paper>
    );
  }

  const timestamps = rows.map((r) => formatTimestamp(r.timestamp, timeRange));
  const status2xx = rows.map((r) => r.status_2xx ?? 0);
  const status4xx = rows.map((r) => r.status_4xx ?? 0);
  const status5xx = rows.map((r) => r.status_5xx ?? 0);

  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1, color: '#01426A' }}>
        Requests by Status Code
      </Typography>
      <Box sx={{ width: '100%', height: 300 }}>
        <BarChart
          height={270}
          xAxis={[{ data: timestamps, scaleType: 'band' }]}
          series={[
            { data: status2xx, label: '2xx', color: '#2e7d32', stack: 'status' },
            { data: status4xx, label: '4xx', color: '#f9a825', stack: 'status' },
            { data: status5xx, label: '5xx', color: '#d32f2f', stack: 'status' },
          ]}
          slotProps={{ legend: { direction: 'row', position: { vertical: 'top', horizontal: 'middle' } } }}
        />
      </Box>
    </Paper>
  );
};

export default RequestsChart;
